import React, { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

//All Loading related components
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import CommonLayout from "../Common/Layout";
import UserConnectionClass from "../../service/userConnection";
import useWindowResize from "../../hooks/useWindowsReszie";

const DataAnalytics = () => {
  const navigate = useNavigate();
  const { Workspace_id } = useParams();
  const workspace = useSelector((state) => state.workspace);

  const { Name: workspaceName } = workspace.workspace;
  const connections = workspace.connections;

  const dataAnalyticConnection = useMemo(
    () => connections.find((connection) => connection.Type === "Jupyter") || false,
    [connections]
  );
  const analyticsName = dataAnalyticConnection?.Detail?.name;

  const [loading, setLoading] = useState(false);

  const [analyticsUrl, setAnalyticsUrl] = useState("");
  const [analyticsAuthUrl, setAnalyticsAuthUrl] = useState("");

  const { height } = useWindowResize();

  useEffect(() => {
    if (!dataAnalyticConnection) return navigate(`/my-workspaces/${Workspace_id}`);

    const connectWithDataAnalytic = async () => {
      setLoading(true);
      const UserConnection = new UserConnectionClass();
      const resultConnect = await UserConnection.connectDataAnalytic();
      setAnalyticsAuthUrl(resultConnect.data);
      setLoading(false);
    };

    connectWithDataAnalytic();
  }, [Workspace_id, dataAnalyticConnection, navigate]);

  const handleAnalytic = () => {
    setAnalyticsUrl(analyticsAuthUrl.auth_url);
  };

  const breadcrumbArr = [
    { link: "/my-workspaces", displayName: "Workspaces", active: false },
    { link: `/my-workspaces/${Workspace_id}`, displayName: workspaceName, active: false },
    { link: "#", displayName: "Data Analytics", active: true },
  ];

  return (
    <CommonLayout title="Data Analytics" loading={loading} breadcrumbArr={breadcrumbArr}>
      <Backdrop sx={{ backgroundColor: "transparent", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) => {
            return theme.palette.TiffanyBlue.main;
          },
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {analyticsUrl && (
          <iframe title={analyticsName} src={analyticsUrl} width="100%" height={`${height - 75}px`} scrolling="yes" />
        )}
        {analyticsAuthUrl && (
          <iframe
            src={analyticsAuthUrl.logout_url}
            width="0"
            height="0px"
            style={{ display: "none" }}
            onLoad={() => handleAnalytic()}
            scrolling="yes"
          />
        )}
      </Box>
    </CommonLayout>
  );
};

export default DataAnalytics;
